"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackI18n = exports.getPackLocale = void 0;
var mapKeys_1 = __importDefault(require("lodash/mapKeys"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var i18n_1 = require("./i18n");
var const_1 = require("../const");
function getPackUrl(_a) {
    var packId = _a.packId, packVersion = _a.packVersion, _b = _a.env, env = _b === void 0 ? 'pre' : _b;
    if (env === 'pre') {
        if (packVersion) {
            return "".concat(const_1.URL['pack-daily'], "/upload/pack/").concat(packId, "/").concat(packVersion, "/lang.js");
        }
        return "".concat(const_1.URL['pack-daily'], "/upload/pack/").concat(packId, "/lang.js");
    }
    if (packVersion) {
        return "".concat(const_1.URL['pack-prod'], "/upload/pack/").concat(packId, "/").concat(packVersion, "/lang.js");
    }
    return "".concat(const_1.URL['pack-prod'], "/upload/pack/").concat(packId, "/lang.js");
}
var getPackLocale = function (_a) {
    var packId = _a.packId, packVersion = _a.packVersion, _b = _a.env, env = _b === void 0 ? 'pre' : _b;
    return fetch(getPackUrl({ packId: packId, packVersion: packVersion, env: env })).then(function (res) { return res.text(); }, function () {
        return '';
    }).then(function (cdnLocale) {
        if (!cdnLocale) {
            return null;
        }
        var matchs = cdnLocale.match(/const\scontent\s=\s(.+);if\s?\(window\._PANDA_I18N\)/);
        if (!matchs) {
            return null;
        }
        var langDataMap = (0, mapKeys_1.default)(JSON.parse(matchs[1]), function (v, key) { return key.replace('_', '-'); });
        var parsedLocale = (0, mapValues_1.default)(langDataMap, function (item) {
            return item ? (0, mapValues_1.default)(item.copyList, function (_copy) { return _copy.content; }) : {};
        });
        return parsedLocale;
    });
};
exports.getPackLocale = getPackLocale;
var getPackI18n = function (_a) {
    var packId = _a.packId, packVersion = _a.packVersion, _b = _a.env, env = _b === void 0 ? 'pre' : _b;
    return (0, exports.getPackLocale)({ packId: packId, packVersion: packVersion, env: env }).then(function (parsedLocale) {
        return parsedLocale ? (0, i18n_1.init)({
            locale: parsedLocale,
        }) : null;
    });
};
exports.getPackI18n = getPackI18n;
